import React, { useState } from "react";
import TopHeader from "./TopHeader";
import ChatModal from "./ChatModal";

export default function PageShell({
  title,
  children,
  searchQuery,
  setSearchQuery,
  cart,
  currentUser,
  logout,
}) {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div>
      <TopHeader
        title={title}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        cart={cart}
        currentUser={currentUser}
        onLogout={logout}
      />

      <button
        className={chatOpen ? "chatFab chatFabOpen" : "chatFab"}
        onClick={() => setChatOpen((v) => !v)}
        type="button"
        aria-label={chatOpen ? "Close chat" : "Open chat"}
        title={chatOpen ? "Close" : "Chat"}
      >
        {chatOpen ? "×" : "💬"}
      </button>

      <ChatModal visible={chatOpen} onClose={() => setChatOpen(false)} />

      <main className="container pagePadBottom">{children}</main>
    </div>
  );
}
